import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "doc_content" }, {
        default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createElementVNode("h2", null, "404 - Die angeforderte Seite wurde nicht gefunden.", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("p", null, [
                _createTextVNode(" Wir werden diesem Fehler sobald wie möglich nachgehen. Du kannst mit "),
                _createElementVNode("a", { href: "/" }, "diesem Link auf die Startseite"),
                _createTextVNode(" zurückzukehren. ")
            ], -1)),
            _createElementVNode("p", null, [
                _cache[0] || (_cache[0] = _createTextVNode(" Wurdest du von uns in den Trend-Monitor eingeladen und kannst nun deine Arbeit nicht mehr fortsetzen? Dann wären wir sehr froh über eine kurze Nachricht via ", -1)),
                _createElementVNode("a", {
                    href: `mailto:xwym@zhaw.ch?body=Liebes%20Team von Zürich Sozial,%20ein%20404-Fehler%20ist%20aufgetreten.%20AuthID:${_ctx.userid ? _ctx.userid : '-'}&subject=Fehler404%20-%20${_ctx.currentHref}`
                }, "xwym@zhaw.ch", 8, _hoisted_1),
                _cache[1] || (_cache[1] = _createTextVNode(". ", -1))
            ])
        ]),
        _: 1
    }));
}
